import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import AddIcon from '@mui/icons-material/Add';

interface EmptyStateProps {
  title?: string;
  message?: string;
  actionText?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  title = "Nenhum item encontrado", 
  message = "Não há itens para exibir nesta lista.",
  actionText,
  onAction
}) => {
  return (
    <Paper 
      elevation={1}
      sx={{ 
        p: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        my: 2,
        backgroundColor: 'background.default'
      }}
    >
      <InboxIcon sx={{ fontSize: 60, mb: 2, color: 'text.secondary' }} />
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {message}
      </Typography>
      {actionText && onAction && (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onAction}
          startIcon={<AddIcon />}
        >
          {actionText}
        </Button>
      )}
    </Paper>
  );
};

export default EmptyState;
